import DOMPurify from "dompurify";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import './message.css';
import 'typeface-roboto';

import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style

import { RiCustomerService2Line } from "react-icons/ri";

import user from '../../img/user.png';

function normalizeAIText(text) {
  if (typeof text !== 'string') return '';
  const withoutEscapes = text
    .replace(/\\n/g, '\n')
    .replace(/\\t/g, '\t');
  const withoutBody = withoutEscapes
    .replace(/^\s*<\s*body\b[^>]*>/i, '')
    .replace(/<\/\s*body\s*>\s*$/i, '');

  return DOMPurify.sanitize(withoutBody);
}

function Message({ message, who, smooth }) {
  const isAI = who === 'AI';
  const mySafeHTML = !isAI
    ? DOMPurify.sanitize(message, {
        ADD_TAGS: ["iframe"],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
      })
    : null;

  return (
    <div className="container__line">
      <div className={who === 'User' ? 'container__UserMessage' : 'container__AIMessage'}>
        {isAI ? <div className='message__circle' style={{ marginRight: 10 }}> <RiCustomerService2Line /> </div> : <></>}
        <div className='message' style={{ fontFamily: 'Roboto' }}>
          {isAI && message === '' ? <div className="loadingDots"></div> : null}
          {isAI && message !== '' ? (
            <div className="aiMarkdown message__content">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                  body: ({ children }) => <>{children}</>,
                  a: ({ href, children, ...props }) => (
                    <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
                      {children}
                    </a>
                  ),
                }}
              >
                {normalizeAIText(message)}
              </ReactMarkdown>
            </div>
          ) : null}
          {!isAI ? (
            <>
              {smooth ? (
                <div className='message--visible' dangerouslySetInnerHTML={{ __html: mySafeHTML.replace(/href/g, "target='_blank' href") }} />
              ) : (
                <div className='message--visible' dangerouslySetInnerHTML={{ __html: mySafeHTML.replace(/href/g, "target='_blank' href") }} />
              )}
              <div className='message--notVisible' dangerouslySetInnerHTML={{ __html: mySafeHTML.replace(/href/g, "target='_blank' href") }} />
            </>
          ) : null}
        </div>
        {who === 'User' ? <div className='message__circle' style={{ marginLeft: 10 }}> <img src={user} alt='user' className='icon' /> </div> : <></>}
      </div>
    </div>
  );
}

export default Message;
